function getBoolItemFromSessionStorage(itemName, defaultValue = true) {
	return localStorage.getItem(itemName) !== null ? 
		localStorage.getItem(itemName) === 'true' : 
		defaultValue;
}

export default {
	dataLoading: true,
	dataLoaded: false,
	// notLoggedIn: false,
	mainSidebarOpenState: getBoolItemFromSessionStorage('mainSidebarOpenState', true),
	secondSidebarOpenState: getBoolItemFromSessionStorage('secondSidebarOpenState', true),
	accountSubmenuOpenState: getBoolItemFromSessionStorage('accountSubmenuOpenState', true),
	eventSubmenuOpenState: getBoolItemFromSessionStorage('eventSubmenuOpenState', false),
	merchandiseSubmenuOpenState: getBoolItemFromSessionStorage('merchandiseSubmenuOpenState', false),
	notificationsState: false,
	notifications: [],
	showWelcomePopup: false,
	loggedOut: false,
	logoutTime: localStorage.getItem("logoutTime") || null,
	searchTerm: localStorage.getItem("searchTerm") || '',
};
